import { type PropsWithChildren, Suspense } from 'react';
import { LoadingState } from '@localagent/ui/components/shogun-spinner';

/** Suspense boundary for the lazy web auth tree — no Stytch imports. */
export function WebAuthSuspense({ children }: PropsWithChildren) {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center bg-muted">
          <LoadingState label="Loading authentication…" />
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
